<template>
  <v-btn
    v-bind="{
      color: brandPrimary,
      height: 48,
      rounded: true,
      block: true,
      theme: 'dark',
      variant: 'flat',
      ...$props,
      ...$attrs,
    }"
  >
    <slot />
  </v-btn>
</template>
<script>
import { useColors } from '@/composables/colors';

export default {
  name: 'DpplSignupFormButton',
  setup() {
    const { brandPrimary } = useColors();

    return { brandPrimary };
  },
};
</script>
<style scoped>
.v-btn.v-btn--size-default {
  font-size: 16px;
  text-transform: capitalize;
}
</style>
